import angular from 'angular';

const NUMERIC_MODEL_KEYS = [
  'overtimeWeekMultiplier',
  'overtimeDayMultiplier',
  'spreadOfHoursPay',
  'laborPercent',
  'holidayRateMultiplier',
];

const DATE_MODEL_KEYS = ['payrollPeriodStartDate', 'payrollPeriodStartDateTwo'];

export default function LaborSettings(Restangular, PersonaCollection, Utils) {
  'ngInject';

  Restangular.extendModel('labor/settings', (model) => {
    const result = _transformNumeric(model);
    result._overtimeWeekThresholdHours = result.overtimeWeekThreshold / 60 || 0;
    result._spreadOfHoursThresholdHours = result.spreadOfHoursThreshold / 60 || 0;

    DATE_MODEL_KEYS.forEach((key) => {
      if (result[key]) {
        result[key] = Utils.getRealDate(result[key]);
      }
    });

    if (result.access) {
      result.access = result.access.map((persona) => {
        if (persona.id in PersonaCollection.personasDict) {
          return Utils.extendWithProps(PersonaCollection.personasDict[persona.id], {}, [
            'id',
            'type',
            'name',
            'color',
            'fullname',
            'employeeId',
          ]);
        }

        return Restangular.restangularizeElement(null, persona, 'personas');
      });
    }

    return result;
  });

  Restangular.addRequestInterceptor((element, operation, what) => {
    let returnElement = element;
    if (operation === 'put' && what === 'labor/settings') {
      // empty strings (clear form inputs) are not being saved on backend so make sure we send numeric values
      returnElement = _transformNumeric(element);

      DATE_MODEL_KEYS.forEach((key) => {
        if (returnElement[key] && angular.isDate(returnElement[key])) {
          returnElement[key] = Utils.formatDate(returnElement[key]);
        }
      });
    }

    return returnElement;
  });

  function _transformNumeric(model) {
    NUMERIC_MODEL_KEYS.forEach((key) => {
      model[key] = typeof model[key] !== 'undefined' ? Number(model[key]) : 0;
    });

    return model;
  }

  return Restangular.service('labor/settings');
}
